var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPdpBasket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 1.5l5.626 4.72h1.374a.75.75 0 010 1.5h-.092l-1.12 8.522a1.685 1.685 0 01-1.712 1.479H4.176c-.962 0-1.608-.686-1.713-1.48l-1.12-8.52H1.25a.75.75 0 010-1.5h1.374L8.25 1.5a1.5 1.5 0 113 0zM9.75 3c.265 0 .513-.069.73-.189l4.062 3.41H4.958L9.02 2.81c.216.12.464.189.729.189zM2.855 7.72h13.79l-1.094 8.326c-.013.1-.084.175-.225.175H4.176c-.142 0-.213-.075-.226-.175L2.855 7.721zM14 9.22a.75.75 0 00-.75.75v4.5a.75.75 0 001.5 0v-4.5a.75.75 0 00-.75-.75zm-3.583.75a.75.75 0 011.5 0v4.5a.75.75 0 01-1.5 0v-4.5zm-2.084-.75a.75.75 0 00-.75.75v4.5a.75.75 0 001.5 0v-4.5a.75.75 0 00-.75-.75zm-3.583.75a.75.75 0 011.5 0v4.5a.75.75 0 01-1.5 0v-4.5z",
    fill: "#fff"
  })));
}

export default SvgPdpBasket;